import { render, staticRenderFns } from "./studentForm.vue?vue&type=template&id=8226c812&scoped=true&"
import script from "./studentForm.vue?vue&type=script&lang=js&"
export * from "./studentForm.vue?vue&type=script&lang=js&"
import style0 from "./studentForm.vue?vue&type=style&index=0&id=8226c812&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8226c812",
  null
  
)

export default component.exports